<template>
  <div class="first">
    <div v-if="!projectId">首页内容</div>
    <!-- <a-tabs v-else v-model="activeKey" >
      <a-tab-pane key="1" tab="项目概览"> -->
        <overview></overview>
      <!-- </a-tab-pane>
      <a-tab-pane key="2" tab="项目资料" force-render>
        <view-info></view-info>
      </a-tab-pane>
    </a-tabs> -->
    <!-- <div class="fixed-message-notice">
      <MessageNotice />
    </div> -->
  </div>
</template>

<script>
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Overview from '@/views/project/view/Overview1'
  import viewInfo from '@/views/project/view/Info'
  import Vue from 'vue'
  // import MessageNotice from '@/comp/mes/MessageNotice.vue'
  // import MessageNotice from '@/components/mes/MessageNotice.vue'
  // import BaseFormView from '@comp/form/BaseFormView.vue'

  export default {
    name: "Analysis",
    components: {
      Overview,
      viewInfo,
      // MessageNotice,
      // BaseFormView,
    },
    provide(){
      return {
        viewInfoFn:this.viewInfoFn
      }
    },
    data() {
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        activeKey:'1',
      }
    },
    created() {

    },
    methods: {
      viewInfoFn(){
        this.activeKey='2'
      }
    }
  }
</script>
<style lang="less" scoped>
/deep/ .ant-tabs-bar{
  margin-bottom: 0;
}
.fixed-message-notice {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
}
</style>